import {
  isKnownPhoneVersion,
  validateCaseBundle,
} from "../../case-spec";
import { rewritePlaceholdersForStructuralValidate } from "../../worker/pipeline/placeholders";

export type EditorValidateIssue = { path: string; message: string };

export function pinPhoneVersionForValidate(
  phoneRuntimeVersion?: string | null,
): string | undefined {
  return phoneRuntimeVersion && isKnownPhoneVersion(phoneRuntimeVersion)
    ? phoneRuntimeVersion
    : undefined;
}

/** Structural validate for the editor. Placeholders do not fail URL format. */
export function validateEditorPhoneJson(
  value: unknown,
  phoneRuntimeVersion?: string | null,
): { ok: boolean; errors: EditorValidateIssue[] } {
  const phoneVersion = pinPhoneVersionForValidate(phoneRuntimeVersion);
  const forValidate = rewritePlaceholdersForStructuralValidate(value);
  const result = validateCaseBundle(forValidate, { phoneVersion });
  return {
    ok: result.ok,
    errors: result.errors.map((issue) => ({
      path: issue.path,
      message: issue.message,
    })),
  };
}
